import { ZeroData } from 'azure-devops-ui/ZeroData';
import React from 'react';
import GridLoader from 'react-spinners/GridLoader';

interface ILoadingProps {
  title: string;
  subtitle: string;
}

export default function Loading(props: ILoadingProps) {
  return (
    <div className='full-width full-height loading'>
      <ZeroData
        primaryText={props.title}
        secondaryText={
          <div>
            <div className='margin-bottom-16'>{props.subtitle}</div>
            <GridLoader
              color='#0285a9'
              loading={true}
              size={15}
              aria-label='Loading Spinner'
              data-testid='loader'
            />
          </div>
        }
        imageAltText='Loading'
        imagePath={require('../img/TheAgents.png')}
      />
    </div>
  );
}